export const enum RESPONSE_CODES {
  SUCCESS = 200,
  CREATED = 201,
  FORBIDDEN = 403,
  NO_DATA_FOUND = 404,
  DATA_INTEGRITY_ERROR = 409,
}
